import React from 'react';
import { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";
import './style.css';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
//import PlayerVideo from '../../components/VideoPlayer/VideoPlayer';
import PlayerVideo from 'components/VideoPlayer/VideoPlayerV2';
// eslint-disable-next-line no-unused-vars
import LinkTo from 'components/LinkTo/LinkTo';
import { user_Status } from 'Api/Api';
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import Avatar from 'Assets/avatarnew.svg';
import Button from 'components/Button/Button';
import { local_routes } from 'utils/Routes';
import ContactReportModal from 'components/ContactReportModal/ContactReportModal';
import Modal from "react-bootstrap/Modal";

function SpotLight(props) {
  const [imageAvatar, setImageAvatar] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (props.avatar_image_url !== undefined) {
      let url = props.avatar_image_url;
      let array = url.split("/");
      setImageAvatar(`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_125x125/${array[5]}`)
    }
  }, [props.avatar_image_url])

  // Toogles modal show
  const showModal = () => {
    setShow(true);
  }
  // Toogles modal hide
  const hideModal = () => {
    setShow(false);
  }
  
  let workspace_base_url="";
  let headline = `Featured PechaKucha ${props.city_or_channel_name} Presentation`;
  if (props.workspace_base_url) {
    workspace_base_url = props.workspace_base_url;
    headline = `Spotlighted ${props.city_or_channel_name} Presentation`;
  }

  let full_name = props.full_name;
  if (!full_name) {
    if (props.firstName && props.lastName) {
      full_name = props.firstName + ' ' + props.lastName;
    } else if (props.lastName) {
      full_name = props.lastName;
    } else if (props.firstName) {
      full_name = props.firstName;
    } else {
      full_name = 'Unknown';
    }
  }
  
  let applaud_count = 0;
  if (props.noOfLikes) {
    applaud_count = props.noOfLikes;
  }
  
  return (
    <React.Fragment>
      <div className="main-section">
        
        <div className="spotlightVideo" style={{ marginTop: "0px", marginBottom: "0px" }}>
          
          <div className="container">
            <div className="videotitle">
              <NavLink to={`${workspace_base_url}${local_routes.presentations}/${props.friendly_url}`}>
                <h2>{headline}</h2>
              </NavLink>
              <br/><br/><br/>
            </div>
            <Row >
              
              <Col sm={12} md={12} lg={8}>
                <div className="city-video">
                  <PlayerVideo
                    key={props.presentation_data.entity_uuid}
                    presentation_data={props.presentation_data}
                    autoPlayStatus={false}
                  />
                </div>
              </Col>
              <Col sm={12} md={12} lg={4}>
                <div className="city-det">
                  <NavLink to={`${workspace_base_url}${local_routes.presentations}/${props.friendly_url}`}>
                    <h3>{props.entity_name}</h3>
                  </NavLink>
                  <div className="media-options">
                    <div className="left">
                      {/* <a href=""><i className="fa fa-save"></i></a> 
                      <a href=""><i className="fa fa-share-alt"></i></a> */}
                      {/* <LinkTo mailTo={props.mailTo} text={props.textReport} iconName={props.iconName} /> */}
                      <Modal size="lg" show={show} onHide={hideModal} className="modal-content-custom" >
                          <div><ContactReportModal modalText = "Please use the 'Support' button in the lower right" /></div>
                          <div>
                              <Button theme="modal-button" OnClickMet={hideModal}>
                                  x
                          </Button>
                          </div>
                      </Modal>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a onClick={showModal}><i className="fa fa-flag"></i></a>
                    </div>
                    <div className="right">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a className="likeBtn"><i className={props.iconNameLike}></i>{applaud_count}</a>
                      {
                        user_Status === 1 ?
                          <React.Fragment>
                            {
                              props.likeLoader === true ?
                                // <ActivityIndicator theme="button-Loader-Minimal" themeSpinner="spinner-border like-btn" />
                                <ActivityIndicator theme="spinnerbgBlack likeSpinner"/>
                                :
                                <React.Fragment>
                                  <a onClick={props.handleClick} className="like-label like-media">
                                    {props.likeLabel}
                                  </a>
                                </React.Fragment>
                            }
                          </React.Fragment>
                          : null
                      }
                    </div>
                  </div>
                  {
                    full_name ?
                      
                      props.presenter_friendly_url ?
                        <NavLink to={`${workspace_base_url}${local_routes.users}/${props.presenter_friendly_url}`}>
                          <div className="media-author">
                            <img alt='author' src={imageAvatar ? imageAvatar : Avatar} />
                            <h4>{full_name}</h4>
                            <span>{props.designation !== undefined ? props.designation : null}</span>
                          </div>
                        </NavLink>
                      :
                        <div className="media-author">
                          <img alt='author' src={imageAvatar ? imageAvatar : Avatar} />
                          <h4>{full_name}</h4>
                          <span>{props.designation !== undefined ? props.designation : null}</span>
                        </div>
                    : null
                  }

                  <div dangerouslySetInnerHTML={{ __html: (props['description'] !== undefined && !null) ? props['description'] : null }} className="videoDescription" />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}


export default SpotLight;